module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0xvi-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0xvii-01.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "intro",
    attrs: {
      "id": "intro"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The possibility of reaching a clear understanding of Roman warfare, based on its consistent organic development, has unfortunately been prevented by the extensive fragmentation of the relevant monograph literature (…), so that one can say, like Kahrstedt, that one would have to live to be a hundred in order to have read everything; it seems all the more impossible to deal only with the majority of it in a regionally limited summary presentation. For better or worse, the writer must run the risk that the accusation is later made of them by another author that they had not taken into account or refuted in detail their or any other work.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("(Georg Veith, 1928)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From the outset, the army was the most important prop for the government and provincial administration of the Caesars during the Roman Principate. With the help of his armies, Augustus was successful in the civil war against Marc Antony and other opponents. After the victory, the new autocrat reduced, reformed, and reorganized the civil war armies as an imperial army, the most important pillars of his power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By modern standards, the uniformly drilled and armed professional army of the Roman Empire was – in terms of their various duties and the number of their external enemies – amazingly small in size. It is only possible to cite approximate estimates for the total strength of the Roman army during the 1st to 3rd centuries AD. With legions, auxiliaries, marines, and guard units, it should have amounted to between 400,000 and 500,000 men."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN1",
      "id": "IF1"
    }
  }, [_vm._v("1")])]), _vm._v(" Local militias could even be used in times of crisis, but there is still no clarity about their structure and scope from research. Against the background of the considerable extent of the Roman Empire around the Mediterranean in the imperial period, peace and security of the Empire were guaranteed by only a relatively small number of professional soldiers. The reasons why so few soldiers were sufficient for the protection and control of the Empire are manifold. In addition to the good training and leadership of the Roman troops, armament and equipment superior to that of their opponents certainly played a particularly large role. Infrastructure – such as strong camps and forts, border inspection facilities, and roads, which facilitated adequate supplies and rapid troop movements – also secured the military superiority of Rome over a long period.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In relation to the enormous extent of the empire, the modest strength of the Roman army of the Imperial era seems even more surprising, if one bears in mind that its tasks in many areas went far beyond what is nowadays associated with the duties and activities of a modern army. First of all, the Roman army fulfilled the classic function, acting as an armed power of the state, as represented by the "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("emperor, in external and internal conflicts. In other words, they guarded the borders, responded to external aggression, led wars of conquest, and also protected the emperor and the political system he represented from internal enemies, in the worst case in costly civil wars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, however, the troops also undertook functions that are nowadays the job of the police, economic police, customs, and tax authorities. Even that was not enough: as part of their service, Roman soldiers were just as active as road builders, architects, contractors, manufacturers of building materials in quarries and brickyards, and as lumberjacks. The Roman military not only constructed its wooden and stone field and base camps and various other military buildings themselves – from legionary fortress to frontier watchtower – but the experienced military engineers could also build fort baths, roads, canals, bridges, and ships, with the help of trained military craftsmen and ordinary soldiers as labourers and workmen, without any help from civilian forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, the legions frequently made their specialists available to auxiliary troops for more complicated work, as evidenced by many building inscriptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Legionary soldiers, mostly centurions, led and monitored the construction of the baths, walls, towers, gates, and internal buildings of auxiliary forts. The troops themselves supplied the building materials for all of these installations: from the mid-1st century AD onwards, legions and auxiliary troops often ran their own brickworks, if suitable clay deposits with convenient connections to water for bulk transport were available. Their products were labelled with the monogram of the unit producing them (brick stamps). Quarries were also operated by the army, with the military fleets able to arrange the transport of building materials."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN2",
      "id": "IF2"
    }
  }, [_vm._v("2")])]), _vm._v(" And finally, there is evidence that legionaries were employed for extracting ore using mining technology."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN3",
      "id": "IF3"
    }
  }, [_vm._v("3")])]), _vm._v(" Several reasons underlie all of these (from today’s perspective) non-military activities. Thus infrastructure certainly played an important role in support of the border provinces, which then also benefited the civilian sector. However, steady employment in times of peace was also a means to prevent soldiers getting out of shape or – even worse – harbouring dangerous notions, if they were unhappy about the political situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One result of these non-military activities of Roman soldiers are those buildings – or rather building complexes – which, as a speciality of the Roman army, distinguished them from all other armies in antiquity: regularly laid out camps and forts. Only a few such installations from the time of the Republic compare with large numbers of well-known and researched camps of the early and middle Imperial period. Fortresses are known of all sizes from the period of late antiquity. Incomparably larger and better fortified than the older camps and forts, they illustrate the significant changes in fortification which came with the completion of the reforms of Diocletian (AD 284–305) and Constantine I (306–37). In addition to camps and forts, border fortification systems of all kinds ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limites")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ripae")]), _vm._v("), infrastructure such as roads and canals, as well as specialised buildings like military baths, were among the constructional legacy of the Roman military.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With its regular and good pay, the professional Roman army gained an importance in peacetime for those border provinces where it lay in garrison that should not be underestimated: within their immediate surroundings, soldiers as consumers formed a stable basis for agriculture, industry and trade of every kind."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN4",
      "id": "IF4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Republic, the economic power of the Roman army had already led to the fact that a regular entourage of businessmen, soldiers’ hangers-on, and fortune seekers of all kinds escorted the troops on campaign to take advantage of the soldiers’ regular pay and booty: the slaves and freedmen of soldiers and officers, farmers and traders, slavers, prostitutes, priests and soothsayers – in addition to the legitimate and illegitimate wives and children of soldiers – were the constant companions of Roman armies. Even the risk of dying with the troops, as happened in AD 9 in the Teutoburg Forest, did not stop them."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN5",
      "id": "IF5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the establishment of permanent camps in the early Imperial period, permanent and even town-like civil settlements were set up around legionary camps ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("canabae legionis")]), _vm._v(") and auxiliary forts ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vici")]), _vm._v("), where the camp-followers settled down for good. Stable communities, some of them of considerable size, often developed from the early temporary ‘booths’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("canabae")]), _vm._v("). Many of these Roman military sites in the border provinces formed the basis of settlements that still survive (Fischer 1999a).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the Roman army was not only implanting and safeguarding Roman civilization at the borders of the Empire through its economic power and infrastructure: in the conquered frontier provinces, members of the subdued nations learned to know and appreciate Roman culture, together with the Latin language and writing, as auxiliary soldiers. Quite early after the conquest of the region in question, most legionary and auxiliary soldiers elected to settle down to live in the border regions following their release from military service as veterans. They cultivated the Roman way of life and thus contributed to the progress of Romanization in even the most remote areas of the empire.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiona",
    attrs: {
      "id": "ch101sec1"
    }
  }, [_vm._v("The state of research")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From the beginnings of the study of Roman history, research into the Roman military system was at the forefront in the work of historians. Initially, they could rely primarily on the wealth of richly detailed, written literary sources from antiquity, which increasingly were supplemented with published inscriptions. From the 19th "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("century onwards, the rapidly flourishing archaeological research disciplines also started to contribute significant research results to the study of the Roman army.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the absence of a more recent general work of historical research, the relevant volume of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Handbuch der Altertumswissenschaft")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Handbook of Classical Studies")]), _vm._v(": Krohmayer and Veith 1928) must still be named as the foremost summary in German-speaking countries. A more recent attempt at a synthesis has come from the anglophone countries (Erdkamp 2007). Otherwise, there is an almost endless, and steadily growing, specialised literature on the subject of the Roman army. Meanwhile, the tradition, in the form of literary and written sources, has remained largely unchanged. Yet new epigraphic sources (inscriptions, papyri, ostraca, and graffiti), obtained as archaeological finds, bring ever more new discoveries. One only has to think of the sudden increase in military diplomas in recent years, largely resulting from the use of metal detectors."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN6",
      "id": "IF6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even more dynamic was the increase in knowledge through the work of archaeologists: by means of excavations, the ‘science of the spade’ provides new discoveries and small finds at installations which are closely related to the activities of the Roman military in ever less manageable amounts. Even if not everything brought to light by excavation in recent decades has as yet been published satisfactorily, the ever-increasing volume of a constant flood of monographs and articles makes it ever more difficult for the expert to maintain even a very general overview. This creates a growing need for summary works, at least for research topics on the Roman military, to keep professionals, members of neighbouring disciplines, and other interested parties up to date. This book attempts such a summary of the contributions that archaeology can make towards the study of the army of the Roman Empire, but it cannot and will not be an all-encompassing guide to Roman warfare in general.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In countries with a territorial share of the former Roman frontier provinces, military archaeology is mainly the subject of provincial Roman archaeology."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN7",
      "id": "IF7"
    }
  }, [_vm._v("7")])]), _vm._v(" Therefore, the main focus of the book will comprise the contributions of provincial Roman archaeology to the study of the Roman military.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Iconographic sources for the Roman army are primarily the subject of Classical Archaeology, which has developed the methodological tools to put them in proper context and interpret them; admittedly, not always with sufficient consideration for antiquarian aspects. The increasing specialization of research has meant that, in recent years, the archaeological exploration of Roman maritime and river navigation has become its own special discipline, which includes the study of the Roman navy (Pferdehirt 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In recent years, the rapid increase of the material and the consequent rapid development of relevant studies have inevitably led to growing specialization. The days of the lone, brilliant scientific warrior, with a confident overview of all relevant historical and archaeological aspects of a subject, are numbered. If one nevertheless tries to go it alone, the rapid progress in specialised disciplines carries the implicit danger of spreading outdated or even incorrect views. So in order to gain a broader view beyond the narrow limits of their own discipline, one must work on such a book together with colleagues from related disciplines. This has been attempted in this book. I would like to thank Ronald Bockius, Dietrich Boschung and Thomas Schmidt for readily agreeing to engage in this cooperation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The work presented here is not intended as another popular, non-fiction book on the history and archaeology of the Roman military like those currently in great demand. Rather, it has been attempted as a technically correct, but nevertheless accessibly written, overall view of Roman military archaeology, including selected aspects of ancient historical and epigraphic research. It is intended for professional researchers, staff and students of related disciplines, and for other readers similarly interested in the Roman military.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond these purely scholarly considerations, there is another reason to produce such a summary of Roman weaponry and military equipment: in recent years, popular representations and reconstructions of the Roman army have enjoyed an unexpected and ultimately barely explicable popularity. Alongside the familiar ‘sword-and-sandal’ films (Junkelmann 2008), there have been numerous television productions, mostly British or American in origin. In addition, there are ever more relevant computer games in which the Roman military, with its characteristic weaponry, participates. Similarly, the demand for richly illustrated popular books and magazine publications continues unabated. This development of a distinctive subculture, outside professional scholarly literature, raises mixed feelings: some of these publications are of considerable originality and quality, but others repeat outdated or even incorrect information. The creation and widespread public appearance of ‘Roman’ re-enactment groups (Gilbert 2004; Schrader 2010; Koepfer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et al.")]), _vm._v(" 2012) have greatly assisted popularization of the subject and as yet there seems to be no end to developments in this field. ‘Roman groups’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" enthusiastic amateurs who dress as Roman soldiers in their characteristic armament with a considerable commitment in time and costs, can nowadays frequently be met at ‘Roman festivals’. Increasingly, they also appear on television to bring documentaries about Roman history to life. Accordingly, ‘Roman’ soldiers in this guise are ubiquitous in the daily flood of media images and they dominate the public consciousness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But are this equipment and armament, which are encountered so often that they have has become a stereotype, always truly authentic? In the current public perception in films, books, computer games, and re-enactment, identical images and ideas of the Roman army and Roman soldiers, their clothing and weapons, which are not based on current research, occur again and again. Mostly they show features limited to only a tiny time segment in the centuries-long history of the Roman army: to a time around AD 100. These include a red-painted rectangular shield, plate armour, Weisenau-type helmets, a red tunic, a red cloak, a Pompeii-type sword, and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pilum")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig1"
    }
  }, [_vm._v("Figure 1")]), _vm._v("). Translating these colourful images into black and white inevitably reveals their roots: the representations of the Roman army on Trajan’s Column, with its supposedly uniform standardization. More than any other, it was the characteristic representations on this monument that allowed the Roman army to appear ‘uniform’ and thus ‘modern’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN8",
      "id": "IF8"
    }
  }, [_vm._v("8")])]), _vm._v(" But is this really true? Or do we get tricked into believing representations frequently transmitted by all sorts of media that have nothing to do with ancient reality?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f00xx-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 1")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Parade by legionary re-enactors from around AD 100, with red- and blue-painted rectangular shields, segmental and mail armour, helmets of the Weisenau type, red tunic, red cloak, Pompeii-type sword, and")]), _vm._v(" pilum. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo: J. Pogorzelski")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The constant repetition of images of the Roman army ultimately derived from Trajan’s Column has led to their gaining a considerable and dangerous momentum; in the worst case they will convey factually inaccurate stereotypes to the modern audience, rather than sound, modern scholarly knowledge of Roman armament from a time around AD 100. Quite apart from that, this development has pushed aside the dynamic and steady evolution of weaponry and equipment in the Roman army and with it the conditions in other periods of the Roman Empire. All this is now superseded or even completely ignored by the persistent presence of images of supposedly ‘classic’ Roman soldiers in pictures of Trajan’s Column. Only a few ‘Roman re-enactor groups’ have been able to disconnect themselves from the predominant imagery of Trajan’s Column and are really striving for authenticity and diversity in the selection of models for their armament and equipment. The consequence of this is that they have to produce their "), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v("equipment and armament themselves, modelling it upon original finds. In contrast to this, most ‘weekend Romans’ get their equipment from the Internet – manufactured in India and, in many cases, mass-produced items which are no longer authentic."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN9",
      "id": "IF9"
    }
  }, [_vm._v("9")])]), _vm._v(" And the defining images of Trajan’s Column in many cases served and serve as direct patterns for the weaponry finished in India.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So this book was also written with the declared intention of putting to the test the popular notions and images that are increasingly coming to the fore in the public eye. Where necessary, these images will be critically scrutinized, because the imaginative enthusiasm of amateurs and the dry findings of scholars are not always in harmony!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Actually, this is a shame, because the amount of time and money the many members of ‘Roman groups’ devote to assembling their equipment is considerable. The errors observed in the composition and details of such reconstructed equipment are easily avoidable and could be readily corrected. This is especially relevant, since many re-enactment groups repeatedly emphasize the claim that they are not conducting a game or mere recreational activity, but that they should be seen as engaging in serious, rigorously scholarly experimental archaeology!")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiona",
    attrs: {
      "id": "ch101sec2"
    }
  }, [_vm._v("The iconographic sources")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The contribution of classical archaeology relates to the iconographic sources, in other words the representations of Roman soldiers and their weapons and equipment. These occur on historical reliefs (Koeppel 1983 to 1992), sarcophagi, and gravestones"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN10",
      "id": "IF10"
    }
  }, [_vm._v("10")])]), _vm._v(" but rarely on wall paintings. Decorative weapon friezes often show more-or-less-naturalistic depictions of individual weapons. Among the main iconographic sources for the imperial army are reliefs, such as those from the Cancelleria, Trajan’s Column, and the Marcus Column, or on the victory monument at Adamclisi. However, one cannot just unquestioningly take the images of these historic monuments or sarcophagus representations as evidence of historical reality. On closer inspection, and through comparison of these representations with original items, it frequently turns out that the depictions are not ‘photorealistic’ in the modern sense, claiming to offer accurate and realistic representations of weapons, equipment, and episodes from campaigns and battles. Rather, these representations are often either highly simplified and stylized or even show obsolete types of weapons, in a ‘classical’ Hellenistic Greek form. Therefore, it is definitely necessary to first subject such representations to a critical analysis of the source before viewing them simply as illustrations of historical reality. Dietrich Boschung will deal with these aspects.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiona",
    attrs: {
      "id": "ch101sec3"
    }
  }, [_vm._v("On armament, equipment, and the buildings")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most of what is known today about weapons and military equipment in the Roman period is owed to excavations and discoveries on land or at the bottom of the sea or inland bodies of water. But these only form a small and random selection of what once existed. Thus weapons and parts of weapons made from metal tend to be found fairly often. Components of weapons and equipment made from organic materials ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" wood, leather, or textiles) are only preserved in a few exceptional cases. Likewise, there are often quite diverse reasons and mechanisms for the deposition of weapons and military equipment in the ground; it thus seems useful to also consider selected examples of finds assemblages with relevant material in this book. Finally, a newer area that contributes to the knowledge of Roman weaponry must not be excluded: experimental archaeology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a separate chapter, this book will also deal with the buildings of the Roman army; a subject that has been dealt with intensively by provincial Roman archaeology since its establishment. The reason for this is that this branch of research first developed in the UK, Germany, Switzerland, and Austria, countries whose Roman past had in many ways been determined by the Roman military in what had then been the frontier regions of the Roman Empire. This is also true of the Danube areas of Hungary, Slovakia, Croatia, Slovenia, Serbia, Bulgaria, and Romania. In all of these regions, military structures of all kinds were discovered in excavations, from legionary camps to forts, and from frontiers to warships. In these installations, weapons and equipment were found in large quantities, supplemented by water and hoard deposits or finds from civilian settlements.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Generally, civil settlements in the border provinces belong with military infrastructure. Cities and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vici")]), _vm._v(" very often owed not only their establishment to a military garrison, but were also inhabited by former soldiers. On the one hand, the inhabitants of these places directly played a part in the supply of the troops on the border through the production of and trade in weapons, equipment, and all manner of other goods like glassware, pottery, and imported food products; on the other hand, they were of course equally dependent on the members of the military as consumers. The rural settlement system was also directly geared to the supply of the military. Farm units ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("villae rusticae")]), _vm._v(") were concentrated around larger bases or near frontier forts, where military equipment, possibly from veterans, has occasionally been found. In this manner, archaeology is frequently confronted with traces of the Roman army and corresponding archaeological material in the investigation of non-military settlements. Thomas Fischer will deal with all of these areas.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiona",
    attrs: {
      "id": "ch101sec4"
    }
  }, [_vm._v("Basic information on the history and structure of the Roman army")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although the totality of Roman warfare, and in particular the Republic, is not the subject of this book, it should nevertheless be briefly summarized here. Large parts of this book, dealing primarily with archaeological research, are incomprehensible without a basic knowledge of the research results in ancient history on the structure, organization, and history of the Roman army."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN11",
      "id": "IF11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Republic")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The army of the early Republic was purely a militia, in which conscript citizens had to provide their own weapons and equipment. It is therefore understandable that the cavalry were only recruited from the wealthy classes, later resulting in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("equites")]), _vm._v(", or equestrian order, the second tier of imperial aristocracy below the senatorial order. This militia army was only called up in time of war and then usually from spring to late summer; a year-round standing army did not yet exist. The expansion of Roman territory in Italy soon brought the inclusion into the Roman army of troops from allies, who formed their own legions, following the Roman model. Just as later, the bulk of the cavalry came from the allies and not from the Romans. After the Social Wars of 91–89 BC, all free Italians south of the River Po received Roman citizenship. With that special status also allotted to their troops, these now served in the Roman legions. Finally, with the expansion of the empire outside Italy, the incorporation of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" took place, with troops who were free provincials without Roman citizenship. Initially, these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" were not independently operating units, but were each assigned to specific legions. From the Republic to the early Imperial period they were in fact based in the marching camps of these legions and did not yet have their own forts; this only changed in the Claudian period.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 2")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bronze tablet with inscription dedicated to the")]), _vm._v(" genius "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of")]), _vm._v(" legio III Gallica: GENIO LEGIONIS III GALL (icae) ANTONINIANAE "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("from the time of Caracalla (AD 198–217). The Legion was in Syria at that time (unprovenanced, private collection). Photo: A. Pangerl")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The long Punic Wars and the rise of the Roman Empire to a superpower in particular brought with it a crisis for the old militia army. On the one hand, the Roman peasantry was ruined by protracted war service, but on the other increased involvement outside Italy necessitated a year-round standing army.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So it was only logical for Marius to create a professional Roman army during the Jugurthine War (111–105 BC), where landless Roman citizens (proletarians), who before had only provided the light infantry at best, could now voluntarily enlist in the legions and get paid for it. Thus the so-called military reforms by Marius led to the first professional Roman army, which formed the basis of the Roman army of the Empire. The definitive standing professional army, in whose legions only volunteering Roman citizens were included, was formed under Augustus after protracted civil warfare in the years after 27 BC (Actium). Theoretically, compulsory service for all Roman citizens still existed, but this was only ever used in times of need (as in the Marcomannic Wars of the 2nd century under Marcus Aurelius (AD 161–80). But even then it was possible to evade military service by nominating a substitute.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxii-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 3")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diagram showing the phalanx, manipular and cohort legion (after Filtzinger 1983)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The army of the early Republic (from the 5th century BC) is supposed to have been organized as a Greek-style phalanx ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig3"
    }
  }, [_vm._v("Fig. 3")]), _vm._v("), in which the heavily armoured "), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("infantry soldiers were placed close together in three lines. However, the lines or ranks of the Early Roman order of battle were broken down by armament and age groups, with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastati")]), _vm._v(" in front, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principes")]), _vm._v(" in the centre, and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triarii")]), _vm._v(" in the back row. The ratio was 1:1:1/2. Since the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triarii")]), _vm._v(" were older and more experienced soldiers, the Latin proverb "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("res venit ad triarios")]), _vm._v(" meant, in effect, ‘things are now really serious.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combat was opened by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("velites")]), _vm._v(", lightly armed skirmishers. The long line of battle of a legion was soon subdivided into smaller tactical units for better control and was thus made more flexible. Two companies (centuries) were combined in the new tactical unit of the maniple ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manipulus")]), _vm._v("). Within the legion, the maniples of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastati")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principes")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triarii")]), _vm._v(" were each numbered from 1 to 10, with the size of the centuries varying. At the beginning of the 3rd century, as the war against Pyrrhus (280–275 BC) finished, the manipular legion according to Polybius looked like this:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1200 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastati")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("= 10 maniples of 120 men")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "noindent"
  })]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("= 20 centuries of 60 men")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1200 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principes")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("= 10 maniples of 120 men")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "noindent"
  })]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("= 20 centuries of 60 men")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("600 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triarii")])])]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("= 10 maniples of 60 men")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_c('p', {
    staticClass: "noindent"
  })]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("= 20 centuries of 30 men")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were a further 1,200 lightly armed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("velites")]), _vm._v(", with an unknown structure. This legion therefore had a total theoretical strength of 4,200 soldiers.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_1_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The cohort legion")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With Marius’ reform of the army around 100 BC, a restructuring of the legions is supposed to have occurred, although this is not explicitly stated anywhere, but it seems feasible that the change occurred around this time. It is only recorded that Marius introduced the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aquila")]), _vm._v(", the legionary eagle, as the standard of a legion, implemented some technical improvements to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pilum")]), _vm._v(" (not readily comprehensible from the sources), and reformed the marching pack of the soldiers. The latter earned the soldiers the nickname "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muli Mariani")]), _vm._v(" or Marius’ mules. After these reforms, the maniple was no longer the basic tactical unit of the legion, but rather the cohort. In battle, the ten cohorts deployed side by side, each divided into the established three ranks of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastati")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principes")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triarii.")]), _vm._v(" Cohorts were numbered from 1 to 10, with the first cohort being the most respected as a sort of bodyguard for the commander, while the hierarchy of the centurions in a legion respected this scheme: the centurion of the first cohort served as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("primus pilus")]), _vm._v(", the senior centurion in a legion.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxiii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 4")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theoretical strength of an imperial legion. The figures marked with * are estimates (according to v. Petrikovits 1975 and Dietz and Fischer 1996)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Legions in the Imperial period")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The legion of the Imperial period, which had developed from the legion of the Marian reforms was, tactically and administratively, a self-contained military organization. Internally, the legion was divided in many ways. Duty rosters and administrative procedures were subject to strict regulations, as well as the complicated principles of promotion within a sometimes inscrutable hierarchy (v. Domaszewski 1967). After the military reforms of Marius around 100 BC, professional soldiers who already had Roman citizenship upon entry into the force served in the legion. From then onwards, the tactical basis was the cohort, a subunit of about 500 men, which was further divided into six centuries of 80 combat troops. Each legion consisted of ten cohorts, around 5500–6400 men, with (probably only from the Flavian period) the first cohort, as the leading subunit about twice the size of the others, with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c.")]), _vm._v("800 men. But the actual strength of a legion would rarely have matched the nominal strength. Following H. von Petrikovits (1975), the latter can be simplified as follows (* = pure estimates).")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_2_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Infantrymen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One should not assume that all soldiers of a legion always stayed in camp in peacetime, for several hundred soldiers were assigned to special duties and were often based far outside their garrison sites.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among the soldiers of a legion, there were some 5,000 men serving as combat troops. Most were employed as ‘common’ infantrymen, as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("milites gregarii.")]), _vm._v(" They were enrolled in the legion between 17 and 20 years of age, most having previously learned a craft. They now had every chance to advance in the complicated promotion system of "), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _vm._v("the Roman army. The normal period of service for legionary soldiers was 20 years; an honourably discharged veteran then remained with his unit for a further five years ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("veteranus sub vexillo")]), _vm._v("). After 25 years of service, he was able to return to civilian life with a pension ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praemia militiae")]), _vm._v("), which consisted of cash and/or a land grant. At least in theory: in the early Imperial period there were repeated problems of mutiny, because soldiers were not released on time, but were forced to serve for longer. But it was also possible to continue to serve as a volunteer ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("voluntarius")]), _vm._v("). The veteran with regular service proudly stressed that he was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("missus honesta missione")]), _vm._v(", ‘dismissed with an honourable discharge’. There were also premature retirements as a result of disease ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("missio causaria")]), _vm._v(") or even dishonourable dismissal from the army ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("missio ignominiosa")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common soldiers performed their daily duties within one of the ten cohorts. With the exception of the first, each cohort in turn consisted of six centuries (‘hundreds’) each commanded by a centurion. Eighty common soldiers served in every century; the remaining 20 were composed of specialists such as craftsmen, doctors, soldiers with administrative tasks, legionary riders, and so on. Two centuries formed a maniple in the 2nd and 3rd centuries, by then only important administratively and for the cohesion of the soldiers. Thus, each cohort had three maniples, the legion 30 of them; as the types of armament were named in the same way as in the early days of the Republic – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("triarii")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastati")]), _vm._v(" – the maniples carried the same names. Each maniple had its own standard ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signum")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each legion possessed 120 horsemen ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("equites legionis")]), _vm._v("). They probably served primarily as dispatch riders and messengers. In battle, they fought together with the legion’s auxiliary cavalry, separate from the legion itself.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_2_2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Legionary commanders and military tribunes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The commander of a legion, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legatus Augusti pro praetore legionis")]), _vm._v(", was appointed by the emperor. If only one legion was based in a province, he always also fulfilled the office of governor. He thus administered both the military and the civil administration of a province. The next highest-ranking officer after the legionary legate was a senatorial military tribune, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribunus militum laticlavius.")]), _vm._v(" Since this officer, by birth or by the favour of the emperor, was a contender for the post of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quaestor")]), _vm._v(" (minimum age requirement 25 years) and thus of senatorial rank, he was allowed to wear a broad purple border ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("latus clavus")]), _vm._v(") on his tunic. He was very young, usually only 18 to 20 years old. Nevertheless, he was the highest ranking officer after the legionary commander. Lacking a fixed command role, he was a deputy in the event of war. Such a senatorial military tribune often had a brilliant career in the military and the administration before him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the second tier of Roman nobility came the equestrian military tribunes who, because of the narrow purple stripe on their tunics, were called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribuni militum angusticlavii.")]), _vm._v(" There were five of them in a legion. They too were often at the beginning of great careers in the procuratorial service, for which service as an equestrian officer was a precursor. These equestrian tribunes spent most of their time in administrative tasks. Sometimes they also led a cohort, commanded some special detachments, or helped the commander in other important tasks.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_2_3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Legionary prefects")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The military tribunes were serving in the army for only a relatively short term, quickly continuing their career path of mixed military and civilian postings. Accordingly, they cannot really be called professional soldiers. Their practical military experience was probably not very wide-ranging in most cases. However, there was at least one officer in the command structure of each legion who had worked his way up from recruit as a professional soldier in the army: the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus castrorum")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legionis")]), _vm._v("). In terms of rank, he was below the senatorial tribune, but above the equestrian tribunes. He belonged to the equestrian order. The area of responsibility of legionary prefects could be described as base commander and logistics officer. He was responsible for the camp and the associated legionary territory, also controlling the entire roster including guard duties. In the period from around the Emperor Domitian (AD 81–96) to Emperor Septimius Severus (AD 193–211), they were called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus castrorum")]), _vm._v(" with the occasional addition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legionis")]), _vm._v(", but afterwards just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus legionis")]), _vm._v(". This title they retained even when, after Gallienus (AD 253–68), they commanded the entire legion, because there were now no longer any senatorial officers in the legion, although they had already done so earlier in the absence of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legatus legionis")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribunus militum laticlavius.")]), _vm._v(" All the above-mentioned officers had their own administrations.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_2_4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Centurions")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Centurions can be described as the military backbone of a legion. These officers – equivalent to the modern rank of captain – were professional soldiers through and through. They usually commanded the centuries, administratively and tactically the smallest subunits of a legion. Ultimately, they were responsible for ensuring that, in the event of war, military operations were performed successfully. Therefore, they had to pay particular attention to the maintenance of discipline in troops in time of peace. As part of this duty they enforced the commands of the legion’s high command with the ordinary soldiers. They also monitored the daily routine of the combat troops, drill as well as manoeuvres, preparation of parades, and inspections, and likewise the introduction of new recruits "), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _vm._v("or the cleaning of accommodation. In battle, they were at the forefront. In more peaceful times, centurions also commanded work details of legionaries in mines, quarries, or brick kilns, generally on imperial and state possessions. Sometimes they were temporarily employed as commanders of building detachments, such as for the erection of forts or fort baths for auxiliary units.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a sign of his disciplinary authority, the centurion carried a vine staff and wore greaves, a transverse crest, and a gold ring although, after Septimius Severus, non-commissioned officers ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales")]), _vm._v(") also had these.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most centurions had been promoted from the lower ranks and only achieved their position after 13 to 20 years of service. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("evocati")]), _vm._v(", veterans who voluntarily returned to the colours, also had good career opportunities, most of them being promoted directly to centurions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the number of centuries, there were 60 centurions in a legion. They were allotted to the cohorts and again to the maniples. Since each of the three maniples in a cohort comprised two centuries, each had two centurions. Like military tribunes, these were divided between a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prior")]), _vm._v(" (more experienced) and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("posterior")]), _vm._v(" (less experienced). In pithy military language, therefore, the six centurions in each cohort were named according to the old manipular terms "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pilus prior")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pilus posterior")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("princeps prior")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("princeps posterior")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastatus prior")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hastatus posterior.")]), _vm._v(" The commander of the entire cohort was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pilus prior.")]), _vm._v(" The cohorts in turn were numbered from the first ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prima")]), _vm._v(") to the tenth ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("decima")]), _vm._v("), so that each centurion could be precisely identified. Of course, the difference in rank between the centurions of the second to the tenth cohort was not particularly serious. Only the centurions of the first cohort ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("primi ordines")]), _vm._v(") occupied a special position.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was because the entire first cohort significantly differed from the other nine in many ways. It was almost twice as strong, although it had only six centuries; but it had another 400 soldiers: mainly the ordinary soldiers and NCOs under the legionary prefect, as well as soldiers on long-term duty outside the garrison base. The most senior centurion, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("primus pilus")]), _vm._v(", also led two centuries (Dobson 1978). This position, apparently only held for one year, could even lead to elevation to equestrian rank. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("primus pilus")]), _vm._v(" was first and foremost the centurions’ spokesman with the commander.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After his year in office, this officer (with a minimum age of 50 years) either retired and played a prominent role in his home region or was next promoted to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus castrorum legionis.")]), _vm._v(" With that, his military career was finally over. However, if – after the primipilate – he went to the capital city of Rome and served as a tribune in the fire service ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes vigilum")]), _vm._v("), city cohorts ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes urbanae")]), _vm._v(") or in the imperial bodyguard ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes praetoriae")]), _vm._v(") as tribune, he could return to the legion as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("primipilus iterum")]), _vm._v(" (‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("primus pilus")]), _vm._v(" returning for a second time’); then he occupied a special place on the staff of the legion commander and ranked immediately below the senatorial military tribune. Such men had a good chance of being entrusted with a post as an equestrian in command of a legion in Egypt or even with an imperial procuratorship, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" a high and well-paid administrative office. The majority of the men certainly never got so far and were discharged as centurions. However, during his active career, a centurion did not have to remain with the same legion. The reasons for transfers differed; they might be found on a personal level or could be a result of patronage. Technical specialists also often changed postings.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_2_5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Principales and immunes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One group of soldiers, entrusted with special tasks, ranked above ordinary soldiers but below centurions. They were called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immunes")]), _vm._v(" (exempt from fatigues, corresponding roughly to modern privates) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales")]), _vm._v(" on a slightly higher level (ranking similar to modern NCOs). Since the two terms (the latter first appeared at the beginning of the 2nd century) were not always used unambiguously, it is often not possible to specify the exact rank of individual posts (it is even more difficult to determine possible career structures). In addition, it is to be expected that one or other was subjected to fluctuations in status over time, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i.e.")]), _vm._v(" it would increase or decrease in status. These included the weapons orderlies ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("armorum custodes")]), _vm._v(") assigned to each century. Although they were still among the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immunes")]), _vm._v(" around AD 180, a few decades later they were definitely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales.")]), _vm._v(" The same was probably true for scribes and copyists, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("librarii")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exacti")]), _vm._v(", who, if they worked in the office of the governor, belonged to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sesquiplicarii,")]), _vm._v(" especially in the 3rd century AD. The main difference between the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immunes")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales")]), _vm._v(" lay in their pay and that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales")]), _vm._v(" were exempt from the duties of ordinary soldiers by virtue of rank, while it was granted to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immunes")]), _vm._v(" specifically to exercise their special duties. In turn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principales")]), _vm._v(" were further graded according to whether they received one-and-a-half times or twice the basic pay: whether one was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sesquiplicarius")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dupl(ic)arius.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whoever had achieved this ‘non-commissioned officer rank’, enjoyed further, additional privileges, such as more spacious accommodation and communal areas in camp. Nevertheless, there were differences even within this rank. For daily routine, it was important whether a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principalis")]), _vm._v(" belonged to the combat troops, and thus served in a century (such as, for example, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("optio")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tubicen")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signifer")]), _vm._v(") or on the staff. Among staff positions, another two groups are distinguishable: office posts ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("officiales")]), _vm._v("), "), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _vm._v("designated according to the rank of their officers, and tactical posts which – seconded from the centuries – served on the staff of the governor, like the eagle-bearer ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aquilifer")]), _vm._v("). He carried the standard of the whole legion, topped with a golden eagle. Apparently always a member of the first cohort, he was the highest-ranking NCO not in an office. This post was not always achieved after a long period of service. It seems that sometimes eagle-bearers (there were possibly two per legion) had previously been standard-bearers ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signiferi")]), _vm._v(") and were later even promoted to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("centurio.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxvi-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 5a–b")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pay in the Roman army in the early and middle Imperial period: a) annual pay in sesterces (HS); b) unit pay in sesterces (HS) using the example of a")]), _vm._v(" cohors quingenaria equitata "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(after Gorecki 1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The head of the administrative staff was called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cornicularius")]), _vm._v(", both in military offices as well as in the civil administration of the relevant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("officium")]), _vm._v(" of the governor. He oversaw the lower-ranking clerical staff ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e.g.")]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exacti")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("librarii")]), _vm._v("), and even undertook clerical work himself, especially in the offices of the lower staff officers. If he worked for the legionary commander and governor, he could hope for promotion to centurion. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("beneficiarii consularis")]), _vm._v(" reported directly to the governor. They were used for special tasks, for instance the financial and economic control along roads (Schallmayer 1990 and 1992). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signifer")]), _vm._v(" carried the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signum")]), _vm._v(", a standard with discs attached (Alexandrescu 2010). Apparently, two such standard-bearers belonged to each maniple. In addition, this rank was responsible for monitoring the cohort funds and the savings of the soldiers; he was also responsible for the burial fund. Until the 1st century AD, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("frumentarii")]), _vm._v(" provided their units with grain; accordingly, they derived their name from it ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("frumentum")]), _vm._v(" = grain). Later, however, they were used for various tasks: as messengers and as a supervisory officers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("optio")]), _vm._v(" commanded the century if the centurion was ill or otherwise incapacitated, also helping him with management tasks. As a kind of ‘sergeant’, he was waiting to join the centurionate. Each maniple had a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tubicen")]), _vm._v(", a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tuba")]), _vm._v(" player (or other brass musician), as well as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cornicen")]), _vm._v(" (horn player) (Alexandrescu 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roman soldiers were given regular pay, which was differentiated according to the rank and service grade of the troops, in return for their by no means easy duties ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig5"
    }
  }, [_vm._v("Fig. 5")]), _vm._v("). However, there were deductions from pay for weapons and equipment. In addition, a part of the pay was withheld, to be paid out as a bonus upon honourable discharge from the army – here, something approximating one of the principles of modern national insurance was anticipated. A share of booty during war and one-off donatives upon the accession of a new emperor could on occasion supplement pay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The total number of legions during the Imperial period repeatedly fluctuated due to losses and new formations, but there were never more than 28 units at the same time ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig6"
    }
  }, [_vm._v("Fig. 6")]), _vm._v(").")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxvii-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxviii-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxix-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxx-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxxi-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig6"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 6")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The legions of the Roman Empire from Augustus to AD 300. Design: A. Pangerl")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Auxiliaries")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("(auxilia)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("About the same strength as the legions, there was a second part of the Roman army, the so-called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" or auxiliary troops (Kraft 1951; Spaul 1994 and 2000). In terms of strength, pay, and legal status, these were ‘second-rate’ units. From the mid-1st century BC, auxiliary troops were mainly used for frontier protection, but when in combat, they operated alongside legionary troops. In the Imperial period, auxiliaries provided all of the cavalry (the few mounted legionaries were insignificant in impact). Those free imperial residents from the provinces who did not initially possess Roman citizenship, the so-called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("peregrini")]), _vm._v(" (= strangers) could enrol in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia.")]), _vm._v(" If they had completed 25 years of service and if they had done nothing wrong, then they could get the coveted Roman citizenship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Republic, auxiliary troops were tightly bound to the legions in organization, garrison, and use. They were also housed with them – albeit spatially separated – in the same camps. After the Augustan period, their position changed: they became increasingly independent units and had, from the Claudian period onwards, their own camps – the auxiliary forts.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_3_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" were divided between cavalry and infantry units into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alae")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes")]), _vm._v(", 500 ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quingenaria")]), _vm._v(") or 1,000 ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("milliaria")]), _vm._v(") men strong. Frequently, there were also mixed units, so-called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes equitatae.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohors quingenaria peditata")]), _vm._v(" consisted of six centuries, each of 80 infantrymen under the command of a centurion; including the staff, it was about 500 men strong. Their commander, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praepositus cohortis")]), _vm._v(", usually came from the equestrian order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohors milliaria peditata")]), _vm._v(" consisted of ten centuries, each of 80 infantrymen under the command of a centurion; with staff, it was perhaps about 1,000 men strong. Their commander, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribunus cohortis")]), _vm._v(", usually came from the equestrian order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohors quingenaria equitata")]), _vm._v(" was a mixture of infantry and cavalry. It consisted of six centuries of 80 men under the command of a centurion. To these were added six "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turmae")]), _vm._v(" of cavalry; it was probably about 500 men strong. Their commander, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus cohortis")]), _vm._v(", came from the equestrian order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohors milliaria equitata")]), _vm._v(" was also a mixed unit of infantry and cavalry. It consisted of ten centuries of 80 men commanded by a centurion. In addition, there were ten "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turmae")]), _vm._v(" of 24 cavalrymen, so together with staff the unit was over 1,000 men strong. Their commander, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribunus cohortis")]), _vm._v(", came from the equestrian order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala quingenaria")]), _vm._v(" consisted of 480 horsemen, who were divided into 16 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turmae")]), _vm._v(" of 30, the leader of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turma")]), _vm._v(" being the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("decurio")]), _vm._v(" (not to be confused with that post on a city council). The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala milliaria")]), _vm._v(" consisted of 1,008 horsemen, who were divided into 24 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("turmae")]), _vm._v(" of 42 men. The commander of an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala quingenaria")]), _vm._v(", like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala milliaria")]), _vm._v(", was always a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus alae")]), _vm._v(", drawn from the equestrian order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Commanders of auxiliary cohorts were appointed by the governor of the province in which they were stationed. In contrast, the commanders of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alae")]), _vm._v(", the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefecti alae")]), _vm._v(", were always appointed directly by the emperor in Rome. They completed their military service after the time of Emperor Claudius (AD 41–54) in three tiers, namely in the career of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tres militiae")]), _vm._v(" which corresponded to three grades:")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("1.")]), _vm._v(" Prefect of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohors quingenaria")]), _vm._v(";")]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("2.")]), _vm._v(" Military tribune in a legion ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribunus militum legionis angusticlavius")]), _vm._v(" ) or as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tribunus cohortis milliariae;")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_c('span', {
    staticClass: "num_hang"
  }, [_vm._v("3.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus alae quingenariae.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Then, around the middle of the 2nd century AD, a fourth tier was added for the command of an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala milliaria")]), _vm._v(" with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("militia quarta")]), _vm._v(", only rarely achieved, in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quarta militia equestris")]), _vm._v(", namely the rank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus ala milliariae.")]), _vm._v(" This was the highest military rank that an equestrian could attain, very often paving the way for a procuratorship, managing the financial administration of a province.")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_3_2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nomenclature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While the Romans initially drafted auxiliary troops from the able-bodied young men of newly conquered territories and based them away from the recruitment area, over time the majority of units increasingly came from the hinterland of their base, with only a few exceptions. Often, auxiliary units were named after the tribe from which they had been originally recruited, for example the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohors Raetorum.")]), _vm._v(" However, if such a Raetian cohort was posted in Britain for a long time, for example, the name became merely traditional, because over time the unit came to be formed mainly from provincials, in other words from Britons. In contrast, there were special forces with indigenous weapons or special abilities that were extremely important to the Roman army. These included, for example, the Batavians from the Lower Rhine. They were not only first-class fighters on foot and on horseback, but they could also do what others apparently could not, crossing water in full armour with their horses. They evidently trained in these skills from early youth. So, along with oriental archers (mainly from Syria), they belonged to those auxiliaries who were not just placed in an area and then raised recruits from around their garrison town, but also kept recruiting from "), _c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }), _vm._v("their original recruitment region. Moreover, the officers of these units were aristocrats from the same tribes. There were some auxiliary units ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes civium Romanorum")]), _vm._v(") in which Roman citizens served too, while "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes classicae")]), _vm._v(" were a relic of the Civil War, as they were infantry units formed after 27 BC from marines left over after the battle of Actium.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Auxiliary units were also named after the emperor, or an officer under whom they were founded, for example the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala Flavia")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala Indiana")]), _vm._v(" (after the Treveran noble Julius Indus). There were also numerous honorary names if the whole unit had performed well, for example "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pia fidelis")]), _vm._v(" (reliable, loyal) or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("victrix")]), _vm._v(" (victorious). Special armament was also occasionally added to the title of the unit, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e.g.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sagittariorum")]), _vm._v(" (archers) or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scutata")]), _vm._v(", meaning the troops fought like a legion, with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scutum")]), _vm._v(", the rectangular shield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up to the mid-1st century, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" were still closely tied to the legions, tactically as well as spatially and in their accommodation. Only with the formation of stable frontiers on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limites")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ripae")]), _vm._v(" did the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" win more independence and were posted further away from the legions to man the frontiers. (However, an interesting exception is the legionary fortress at Bonn where an additional "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala")]), _vm._v(" and a cohort were based alongside "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legio I Minervia")]), _vm._v(" until the 3rd century AD.)")]), _vm._v(" "), _c('h5', {
    staticClass: "sub_head",
    attrs: {
      "id": "ch101sec4_3_3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Citizenship")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With his honourable discharge ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("honesta missio")]), _vm._v(") after 25 or more years of service, better times began for the auxiliary soldier. The savings that had been withheld for him in the unit coffers and that had built up over the years were paid out to him in cash; in addition he now finally received Roman citizenship, extending to his wife and his descendants. Through the ‘law of legal marriage’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ius conubii")]), _vm._v("), also awarded to him at that time, an existing or proposed matrimonial alliance with a ‘foreign’ woman was now fully recognized before Roman law. So now he could live in a family recognized by Roman law for the first time! The citizenship acquired via service in the auxiliary troops helped millions of provincials to become the legal and social equals of Roman citizen who had moved to the provinces after the conquest. These privileges, of which the most important were citizenship and legal marriage, were so important that it is no wonder that many soldiers wanted them confirmed in duplicate. These documents had the form of bronze plaques, so-called ‘military diplomas’ ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig7"
    }
  }, [_vm._v("Fig. 7a–d")]), _vm._v("). They contained the text of the imperial decree of the honourable discharge of this soldier from military service, as well as the date, the names and seals of a number of witnesses, the personal data of each recipient and his wife and children, his direct and indirect superiors, as well as a list of all troops affected in the relevant province, an extremely important source for Roman military history (Eck and Wolff 1986; Eck 1997 and 2010a; Pferdehirt 2004). The original of this document was posted publicly at the Temple of Minerva in Rome, so the recipient only received a copy.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Numeri")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From the late 1st century, the so-called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numeri")]), _vm._v(" appeared, ranking below the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(" (Reuter 1999a). These consisted of 100- to 200-strong guard and reconnaissance units, stationed along fixed lengths of frontier. If such units were mounted, they were called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exploratio.")]), _vm._v(" They were under the command of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praepositus numeri")]), _vm._v(", often a centurion seconded from a legion. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Numeri")]), _vm._v(" were used in addition to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alae")]), _vm._v(" and cohorts for frontiers or to explore and secure areas beyond the frontiers, particularly in more remote forest regions, like the Taunus and Odenwald in Germany or on the Dacian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limes.")]), _vm._v(" In contrast to other "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilia")]), _vm._v(", they always seem to have been used in the same province, and always in the same frontier sector; they were not, for example, sent on campaign. This proves that, as local scouts, they were familiar with a particular section of frontier. The names of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numeri")]), _vm._v(" were often formed from the nations from which they had been raised, as with, for example, the diverse "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numeri")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brittonum")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numeri Palmyrenum.")]), _vm._v(" In order to identify a specific unit among the various "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numeri")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brittonum")]), _vm._v(" in Upper Germany, the name of a river or a source in their territory was added to the name of the unit. An example is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numerus Brittonum Elantiensium")]), _vm._v(", named after the River Elz, a tributary of the Neckar.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Guards")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The emperor and the provincial governors were protected by guard units ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig8"
    }
  }, [_vm._v("Fig. 8")]), _vm._v("), whose soldiers were detached from the regular army (Busch 2010). These "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes praetoriae")]), _vm._v(", introduced by Augustus, guarded the emperor and his family and went to war with the emperor. They originally numbered nine cohorts of 1,000 men, each made up of 900 infantry and 100 cavalry. From the time of Tiberius (AD 14–37), they were based in the Praetorian Camp in Rome and were for a long time the strongest military power in and around Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Augustus also introduced a mounted guard of Germans, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germani corporis custodes")]), _vm._v(", although their strength and organization are not known. This unit was disbanded under Galba. Only under Trajan was there a mounted guard again, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("equites singulares Augusti.")]), _vm._v(" Furthermore, there were other special units recruited from troops in.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxxiv-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 7a–d")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Military diploma for troops in the province of Noricum from the time of Titus (AD 79–81) dated 8 September AD 79. issued for the Thracian Gusula(s), son of Doquus. (a outside, b inside), c outside d inside; after White 2004; Eck and Pangerl 2006; unprovenanced, private property). Photo: A. Pangerl")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rome, such as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("speculatores Augusti")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("evocati")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("statores")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("frumentarii")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("speculatores legionis.")]), _vm._v(" In addition, soldiers of the Imperial fleets from Misenum and Ravenna were reassigned to operate the awnings in the circus and in the theatres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To these regular military units were added the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes urbanae")]), _vm._v(", the city soldiers, and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cohortes vigilum")]), _vm._v(", a kind of military fire service and night watch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not until Septimius Severus (AD 193–211) did the military presence of the Praetorians in and around Rome become much stronger. First, the Praetorians were temporarily disbanded and a legion, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legio II Parthica")]), _vm._v(", was stationed in Albano, near Rome; then the theoretical strength of the Guard was increased considerably ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig9"
    }
  }, [_vm._v("Fig. 9")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the praetorian frontier provinces without legionary garrisons, there was a ‘guard’ for the governor consisting of around 250 cavalrymen and infantrymen, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("equites")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pedites singulares")]), _vm._v(", which consisted of selected men from the provincial army. In the provinces with legionary garrisons, the governor’s guard consisted of selected legionaries.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxxv-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 8")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Troops and paramilitary units in Rome during the Imperial period (after Busch 2010)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxxv-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 9")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theoretical strength of troops in Rome during the Imperial period (after Busch 2010)")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxvi"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_6"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Militias")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From the early Imperial period, there were also local militia units in the provinces: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("iuniores")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("iuventus")]), _vm._v(" associations are testified, without details of their number, structure and military armament being known. They gained greater importance, especially in the turbulent times of the 3rd century, and were then more frequently attested epigraphically. Thus the inscription on the Augsburg victory altar names "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("populares,")]), _vm._v(" unspecified militiamen, as jointly responsible for the Roman victory of 24th/25th April 260 over the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Semnones/Iuthungi")]), _vm._v(" (Bakker 1993).")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_7"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The so-called ‘military reform’ of the 4th century AD")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With few exceptions, the Roman army – legionary and auxiliary troops – was based along the frontiers in permanent legionary camps, as well as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ala")]), _vm._v(", cohort, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("numerus")]), _vm._v(" forts, from the time of Augustus ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig10"
    }
  }, [_vm._v("Fig. 10")]), _vm._v("). Apart from the Praetorians and bodyguards of the emperor, Italy had no military presence; only from the time of Septimius Severus (193–211) was there a legion south of Rome, in Albano. This meant that the military high command had no significant mobile reserves present in the interior of the empire to deploy alongside the frontier army.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this system, concentrations of military force, such as were necessary for field campaigns or in the defence of larger attacks, were difficult and time-consuming to accomplish, as ad hoc army groups ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vexillationes")]), _vm._v(") had to be assembled from the various provincial armies to undertake specific combat missions (Saxer 1967). If the task was completed, the individual components of these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vexillationes")]), _vm._v(" returned to their regular units. While this approach generally worked until the 3rd century, or the practical-minded Romans would not have kept it, during the 4th century the weaknesses of it became increasingly obvious. At a time when there were often multiple simultaneous external attacks on the Rhine and Danube frontiers by Germans, Sarmatians, and other opponents, and in the East by the Parthians and then by the Persians, this system simply collapsed. The withdrawal of troops from a momentarily seemingly less-endangered western frontier for field campaigns in the East now meant that Germanic opponents recognized the weakness and regularly took the opportunity to attack the frontier provinces. In addition, the wars between rival claimants to the throne often meant that the best troops of the Empire fought each other, often to the point of almost total annihilation, from the time of Septimius Severus onwards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first large-scale measures to reform the Roman frontier defensive system and get this problem under control can be detected under Gallienus (AD 253–68). Since the effectiveness of the Persians and Germans was probably that they were mostly mounted, a cavalry formation – which was mobile and stationed in Milan – was set up by the emperor from new units to protect Italy and Rome from threat. They could even catch an opponent if they had already broken through the frontier defences and had penetrated far into the hinterland. In late antiquity, this system was perfected with a functional division of the army (border guard troops in garrisons on the frontier, mobile task forces in the hinterland) and introduced throughout the empire. The older view of this dual system as a new introduction in the context of military reform under Diocletian and Constantine is being increasingly called into question by research. Thus, for example, K. Strobel (2007) and Y. Le Bohec (2010) emphasize the continuous development of the comitatensian or mobile army from the mid-Imperial period onwards. However, fundamental changes in the Roman army arrived in the 4th and 5th centuries AD, but are difficult to reconstruct in detail. In general, the Late Roman military system is much less transparent than those of the Republic and the early to mid-Imperial period. Due to their scarcity, written sources generally play a much smaller role for the military history of late antiquity than for the preceding period; the number of inscriptions generally decreased radically, in other words epigraphic evidence with military implications – which previously constituted the most important source for the organization and distribution of Roman troops – disappeared almost completely. Here, even the text originating in the early 5th century AD, the ‘directory of all offices, both civilian and military in the western parts of the empire’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notitia dignitatum omnium, tam civilium quam militarium, in partibus Occidentis")]), _vm._v("), known for short as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notitia Dignitatum")]), _vm._v(", is hardly a substitute. But at least the units of the frontier army and weapon factories are listed in it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From at least the reign of Constantine I (AD 306–24), the Roman army was divided in two: there were now a frontier army permanently based in frontier forts, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limitanei")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("riparienses")]), _vm._v(", and a mobile army operating in the hinterland, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comitatenses.")]), _vm._v(" The frontier units were largely maintained along earlier lines, in terms of formation and tactical designation (legions, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alae")]), _vm._v(", and cohorts), but their theoretical strength was significantly lower than that of the same units of the early and mid-Imperial period. This can be seen from fort sizes, compared to the early and middle Imperial period.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notitia Dignitatum,")]), _vm._v(" the military command of the frontier troops of the Western Empire lay in the hands of the highest-ranking soldier in this part of the Empire, who held various titles and had diverse areas of competence over the course of time. He was called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("magister militum")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("utriusque militiae")]), _vm._v("] (‘master of the army’ or ‘master of all military branches’), or at the Imperial court "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("magister peditum praesentalis")]), _vm._v(" (‘master of infantry present [at court]’); after "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c.")]), _vm._v(" AD 370 he was addressed as Illustrious One ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vir illustris")]), _vm._v("); the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dux limitis")]), _vm._v(" (frontier sector commander) reported to him. Occasionally, this post was filled by one person for several provinces, like the military commander of the two Raetian provinces. He bore the title of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dux provinciae Raetiae primae et secundae")]), _vm._v(" (General of the First and Second Raetian Provinces) with the rank of Admirable One ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vir spectabilis")]), _vm._v(").")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxxvii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 10")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Early modern illustration from the")]), _vm._v(" Notitia Dignitatum "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("showing the forts")]), _vm._v(" Augustanis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Augsburg),")]), _vm._v(" Phoebianis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Bürgle),")]), _vm._v(" Submuntorio "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Burghöfe),")]), _vm._v(" Vallato "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Manching?),")]), _vm._v(" Ripa Prima "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(copyist’s error),")]), _vm._v(" Cambidano "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Kempten),")]), _vm._v(" Guntia "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Günzburg),")]), _vm._v(" Foetibus "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Füssen)")]), _vm._v(" Teriolis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Zirl) and")]), _vm._v(" Qunianis (Künzing) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in Raetia Secunda. The illustrated manuscript was created in 1551 for the Count Palatine Otto Henry (after Garbsch 1994)")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xxxviii"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "sub_level",
    attrs: {
      "id": "ch101sec4_8"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Roman navy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Roman fleet of the Imperial period,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IFN12",
      "id": "IF12"
    }
  }, [_vm._v("12")])]), _vm._v(" like the auxiliary troops of the Roman army, took as recruits free, but legally and socially underprivileged, peregrine residents of the Empire who did not possess Roman citizenship. However, they could gain the coveted Roman citizenship for themselves and their families through military service. However, since naval service was considered more difficult than that of the forces on land and since, with a total of 26–28 years, it was also longer than the 25 years of service for the legions and auxiliary troops, those entering the fleet gained the special privilege of Latin citizenship for themselves from the start – but not for their wives and children. Although this did not offer all the privileges of full Roman citizenship, it was a huge leap forward in legal status for a peregrine provincial. A fleet soldier received full Roman citizenship for himself and his family only upon honourable discharge, after having completed the whole term of service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, this rule did not apply to the officers who, from the outset, had to possess Roman citizenship. The supreme commander of a fleet, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praefectus classis")]), _vm._v(", came from the equestrian order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In organization and jurisdiction, the Roman fleet was divided into two parts ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction#fig11"
    }
  }, [_vm._v("Fig. 11")]), _vm._v("), with a clear distinction apparent between the sailors and the marines. This went so far that every ship had two commanders, one nautical and one military. The nautical commander bore the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nauarchus")]), _vm._v(" on larger vessels, on smaller ships "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trierarchus;")]), _vm._v(" these designations were quite obviously adopted from the eastern Hellenistic area, albeit with a certain change of meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Military crews were equivalent to the centuries of the land army. These consisted of about 80-strong combat units under the command of a centurion. Therefore, there was a marine captain with the rank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("centurio classicus.")]), _vm._v(" Above all, the sailors were often specialized, there being helmsmen, navigators, a man who was on the lookout in the bow, warning of shoals, a coxswain for the rowers, loadmaster, doctors, and others.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxxviii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fig11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 11")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diagram showing the hierarchy of the Roman fleets of the early and middle Imperial period (after Pferdehirt 1995)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A particular theme in Roman military archaeology – the iconographic and textual sources, and especially the "), _c('a', {
    attrs: {
      "id": "page_xxxix"
    }
  }), _vm._v("original remains of Roman warships – has recently led to the development of a separate direction in research: the study of ancient navigation. The discovery of numerous shipwrecks in the Mediterranean, but also of warships used on the Rhine and Danube, like the ships from Mainz and Oberstimm, has brought further advances here. In particular, the Museum for Ancient Navigation ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Museum für antike Schifffahrt")]), _vm._v(") in Mainz (affiliated to the nearby "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Römisch-Germanisches Zentralmuseum")]), _vm._v(") has had a major impact in this as an international research institute. The current state of research into the installations of the Roman fleet, the naval bases, and their warships is dealt with in "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Part04#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part VI")]), _vm._v(" by Ronald Bockius and Thomas Schmidts.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_sectiona",
    attrs: {
      "id": "ch101sec5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes to Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF1",
      "id": "IFN1"
    }
  }, [_vm._v("1.")])]), _vm._v(" Eck 2010a, 90.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF2",
      "id": "IFN2"
    }
  }, [_vm._v("2.")])]), _vm._v(" For example, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Classis Germanica")]), _vm._v(", which – according to inscription "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CIL")]), _vm._v(" XIII 8036 from the time of Antoninus Pius – transported trachyte from Drachenfels near Bonn to Xanten for the construction of the forum. See Precht 2008, 351f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF3",
      "id": "IFN3"
    }
  }, [_vm._v("3.")])]), _vm._v(" However, it is reported that soldiers of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("legio II Augusta")]), _vm._v(" did not see this as a task appropriate to their rank and sent a letter of protest to the Emperor Claudius complaining of their posting to the silver mines in the Taunus, on the right bank of the Rhine (Tac, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann.")]), _vm._v(" 11.20.3; Eich 2010, 26ff.).")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF4",
      "id": "IFN4"
    }
  }, [_vm._v("4.")])]), _vm._v(" Wierschowski 1984; Fischer 2000a; Bender 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF5",
      "id": "IFN5"
    }
  }, [_vm._v("5.")])]), _vm._v(" The possible size of the baggage train can be guesstimated from vague accounts in the context of the civil wars after Nero’s death in the years AD 68/69: thus the convoy of Vitellius in his march on Rome was said to be greater than the force of 60,000 men. Likewise, the 40,000 soldiers of the Flavian army at the second Battle of Cremona were allegedly outnumbered by their retinue. See. Tac., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist.")]), _vm._v(" 2.87; 3.33; Herod. 7.8.10f.; Speidel 2010, 133.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF6",
      "id": "IFN6"
    }
  }, [_vm._v("6.")])]), _vm._v(" Compare just the enormous increase of newly published military diplomas. For example, in Pferdehirt 2004 or Eck and Pangerl 2008 and 2009 respectively.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF7",
      "id": "IFN7"
    }
  }, [_vm._v("7.")])]), _vm._v(" Fischer 2001; 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF8",
      "id": "IFN8"
    }
  }, [_vm._v("8.")])]), _vm._v(" Strobel 2010, 236.")]), _vm._v(" "), _c('p', {
    staticClass: "note_listd"
  }, [_c('span', {
    staticClass: "note_hangd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF9",
      "id": "IFN9"
    }
  }, [_vm._v("9.")])]), _vm._v(" Schrader 2010, 364f.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF10",
      "id": "IFN10"
    }
  }, [_vm._v("10.")])]), _vm._v(" W. Eck in: Beyer 2010a, 174.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF11",
      "id": "IFN11"
    }
  }, [_vm._v("11.")])]), _vm._v(" For this very general overview I have used the following summary literature: Tricholoma 1924–25; Grohmayer and Veith 1963; Webster 1969; v Domaszewski 1967; Dobson 1978; Alföldy, Dobson and Eck 2000; Le Bohec and Wolff 2000; Speidel 2002; Demandt 2007; Le Bohec and Wolff 2004; Strobel 2007; Le Bohec 2010. I would particularly like to thank K. Dietz (Würzburg) for discussion and numerous references.")]), _vm._v(" "), _c('p', {
    staticClass: "note_list1d"
  }, [_c('span', {
    staticClass: "note_hang1d"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#IF12",
      "id": "IFN12"
    }
  }, [_vm._v("12.")])]), _vm._v(" Just see Kienast 1966; Redde 1986; Pferdehirt 1995; Konen 2000.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578cdcc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 75
// module chunks = 0